<template>
  <div class="row">
    <el-dialog
      left
      title="Round Details"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="isShow"
      width="80vw"
    >
      <div class="row">
        <div
          class="col-1 flex-mid"
          v-bind:class="{ link: this.value.currentIndex >= 1 }"
        >
          <i @click="handleClickPrevious" class="fa fa-angle-left fa-lg"></i>
        </div>

        <div class="col-10 investor-table-wrapper">
          <div class="row">
            <div class="col-6">
              <table class="full-width company-field-table">
                <tr>
                  <th>Round:</th>
                  <td>{{ fundingData ? fundingData.funding_type : "" }}</td>
                </tr>
                <tr>
                  <th>Status:</th>
                  <td>{{ fundingData ? fundingData.funding_status : "" }}</td>
                </tr>
                <tr>
                  <th>Pro Rata Rights:</th>
                  <td>-</td>
                </tr>

                <tr>
                  <th>Closing Date:</th>
                  <td>{{ fundingData ? fundingData.announced_date : "" }}</td>
                </tr>
              </table>
            </div>

            <div class="col-6">
              <table class="full-width company-field-table">
                <tr>
                  <th>Total Raised:</th>
                  <td>{{ fundingData ? fundingData.money_raised : "" }}</td>
                </tr>
                <tr>
                  <th>No. of Investors:</th>
                  <td>
                    {{ fundingData ? fundingData.number_of_investors : "" }}
                  </td>
                </tr>
                <tr>
                  <th>Lead Investors:</th>
                  <td>{{ fundingData ? fundingData.lead_investors : "" }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-12" style="margin-top: 10px">
              <tabulator-card
                id="theMainTableBoxFundingRoundDetails"
                class="todos-table-parent companyProfileTabulatorLayout companyProfileTabulatorInvestFundTable"
                :tableData="roundDetails.data"
                :tableOptions="roundDetails.options"
                :tableColumns="roundDetails.columns"
              >
                <template slot="header">
                  <h4 class="card-title companyProfileTabulatorTitle">
                    Investors
                  </h4>
                </template>
              </tabulator-card>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-center" style="margin-top: 10px">
              RECORD {{ this.value.currentIndex + 1 }} /
              {{ this.value.fullData.length }}
            </div>
          </div>
        </div>
        <div
          class="col-1 flex-mid"
          v-bind:class="{
            link: this.value.currentIndex < this.value.fullData.length - 1,
          }"
        >
          <i @click="handleClickNext" class="fa fa-angle-right fa-lg"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import { TabulatorCard } from "src/components/index";
import moment from "moment";
export default {
  name: "dialogfundingrounddetails",
  components: {
    [Dialog.name]: Dialog,
    TabulatorCard,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
      currentIndex: Number,
      fullData: Array,
    },
  },
  computed: {
    moment() {
      return moment;
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        this.$emit("input", this.value);
      },
    },
    fundingData: {
      get() {
        let data = {};
        if (this.value.fullData.length > 0) {
          data = JSON.parse(
            JSON.stringify(this.value.fullData[this.value.currentIndex])
          );
        }
        if (data.announced_date) {
          data.announced_date = this.moment(
            new Date(data.announced_date._d)
          ).format("MM-DD-YYYY");
        }
        return data;
      },
    },
    roundDetails: function () {
      let self = this;

      return {
        data:
          self.fundingData && self.fundingData.investors_list
            ? self.fundingData.investors_list
            : [],
        options: {
          layout: "fitColumns",
          tooltips: true,
          pagination: "local",
          paginationSize: 5,
          paginationSizeSelector: true,
          tooltipsHeader: true,
          initialSort: [{ column: "gain_loss", dir: "desc" }],
          placeholder: "No records to view",
        },
        columns: this.tableColumns,
      };
    },

    tableColumns() {
      const self = this;
      return [
        {
          title: "Investor",
          field: "investor_name",
          sorter: "string",
          minWidth: "200",
          resizable: true,
        },
        {
          title: "Role",
          field: "role",
          sorter: "string",
          resizable: true,
        },
        // {
        //   title: "Shares",
        //   field: "shares",
        //   sorter: "string",
        //   resizable: true
        // },
        {
          title: "Ownership %",
          field: "owner_percent",
          sorter: "string",
          resizable: true,
        },
        {
          title: "Owner Adj",
          field: "owner_adj",
          sorter: "string",
          resizable: true,
        },
        {
          title: "Amount Invested",
          field: "amount_invested",
          sorter: "string",
          resizable: true,
        },
        {
          title: "Price Per Share",
          field: "price_per_share",
          sorter: "string",
          resizable: true,
        },
        {
          title: "Type",
          field: "type",
          sorter: "string",
          resizable: true,
        },
      ];
    },
  },
  watch: {
    isShow: function (val) {
      if (val) {
      }
    },
  },
  methods: {
    handleClickPrevious() {
      if (this.value.currentIndex >= 1) {
        this.value.currentIndex--;
      }
    },
    handleClickNext() {
      if (this.value.currentIndex < this.value.fullData.length - 1) {
        this.value.currentIndex++;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.row {
  text-align: left;
}
.flex-mid {
  display: flex;
  justify-content: center;
  margin-top: 100px;
}
.fa-lg {
  font-size: 40px;
}
.text-center {
  text-align: center;
}

.flex-mid {
  opacity: 0.5;
}
.link {
  color: #0097a7;
  opacity: 1;
  cursor: pointer;
}

.investor-table-wrapper {
  th {
    width: 35%;
  }
}
</style>